import React, { useRef, useState, UIEvent } from 'react';
import { Arrow } from '@icons/common';
import { IconButton } from '@components/IconButton';
import classNames from 'classnames';
import './ScrollableContainer.scss';

interface ScrollableContainerProps {
  className?: string;
  children: React.ReactNode;
}

export const ScrollableContainer = ({ children, className }: ScrollableContainerProps) => {
  const topicsRef = useRef<HTMLDivElement>(null);
  const topicsContainerRef = useRef<HTMLDivElement>(null);
  const [visibleScrollBtns, setVisibleScrollBtns] = useState<Array<'left' | 'right'>>(['right']);

  const onClickScrollBtn = (direction: 'left' | 'right') => {
    topicsRef.current.scrollBy({
      left: direction === 'left' ? -300 : 300,
      behavior: 'smooth',
    });
  };

  const onScrollContent = (e: UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    const { scrollLeft, scrollWidth, clientWidth } = target;
    const scrollRight = scrollWidth - scrollLeft - clientWidth;
    const newShowBtn = [];
    if (scrollRight > 5) {
      newShowBtn.push('right');
    }
    if (scrollLeft > 5) {
      newShowBtn.push('left');
    }
    setVisibleScrollBtns(newShowBtn);
  };

  return (
    <div
      ref={topicsContainerRef}
      className={classNames('scrollable-container', className, {
        [`scrollable-container--${visibleScrollBtns.sort().join('_')}`]:
          visibleScrollBtns.length > 0,
      })}
    >
      {visibleScrollBtns.includes('left') && (
        <IconButton
          className='scrollable-container__scroll-left'
          onClick={() => {
            onClickScrollBtn('left');
          }}
        >
          <Arrow rotate={180} />
        </IconButton>
      )}
      {visibleScrollBtns.includes('right') && (
        <IconButton
          className='scrollable-container__scroll-right'
          onClick={() => {
            onClickScrollBtn('right');
          }}
        >
          <Arrow rotate={0} />
        </IconButton>
      )}
      <div ref={topicsRef} className='scrollable-container-content' onScroll={onScrollContent}>
        {children}
      </div>
    </div>
  );
};
